import { AxiosRequestConfig } from 'axios';
import { useEffectiveCartPayload } from 'hooks/effective-cart/useEffectiveCart';
import { EffectiveCart } from 'interfaces/cart';
import { axios } from 'utils/axios';

type Input = Partial<ReturnType<typeof useEffectiveCartPayload>> & {
  /** if true, request is mede without any personalization headers */
  withoutPersonalization?: boolean;
  /** rule_id for savings plans */
  ruleId?: string;
};

const getPersonalizationConfig = ({
  withoutPersonalization,
  audiences,
}: Pick<Input, 'withoutPersonalization' | 'audiences'>): AxiosRequestConfig => {
  if (withoutPersonalization) {
    return { withoutAudience: true, withoutNinetailed: true };
  }

  if (audiences && audiences.length > 0) {
    return { headers: { audiences: audiences.join(',') } };
  }

  return {};
};

export const fetchEffectiveCart = ({
  items,
  shipping,
  recurring,
  gifts,
  customerId,
  discount,
  ruleId,
  withoutPersonalization,
  audiences,
}: Input): Promise<EffectiveCart> => {
  const payload = {
    effectiveCart: {
      items,
      shipping,
      gifts,
      recurring,
      customerId,
      discount,
      ...(ruleId && { ruleId }),
    },
  };

  return axios
    .post<EffectiveCart>(
      '/checkout/cart/api',
      payload,
      getPersonalizationConfig({ withoutPersonalization, audiences })
    )
    .then(({ data }) => data);
};
